import { IcommonUser } from './icommonuserinterFace';
export class resetpasswordmodel extends IcommonUser {
  DOB: string;
  OTP: string;
  Password: string;
  TansactionID: string;
  OldPassWord: string = '';
  NewPassWord: string = '';
  confirmPassword: string = '';
  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/models/user/user.resetPassword.model.ts